import { render, staticRenderFns } from "./delivery-contract-deal.vue?vue&type=template&id=5dd3c510&scoped=true&"
import script from "./delivery-contract-deal.vue?vue&type=script&lang=js&"
export * from "./delivery-contract-deal.vue?vue&type=script&lang=js&"
import style0 from "./delivery-contract-deal.vue?vue&type=style&index=0&id=5dd3c510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd3c510",
  null
  
)

export default component.exports